var _excluded = ["children", "titleLabel"];
var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/title/Title.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Typography } from '@wds/typography';
import { safeRest } from '@wds/utils';
import { defineMessages, t } from '@sm/intl';
import useStyles from './useStyles';
export var COPY = defineMessages({
  TITLE: {
    id: 'Title.TitleLabel',
    defaultMessage: 'Title of page',
    description: '[Type: Label][Vis.: high] - This is the page title on the header.'
  }
});
export var Title = function Title(_ref) {
  var children = _ref.children,
    _ref$titleLabel = _ref.titleLabel,
    titleLabel = _ref$titleLabel === void 0 ? t(COPY.TITLE) : _ref$titleLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.title
  }, safeRest(rest), {
    "aria-label": titleLabel,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "cardTitle",
    color: "light",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("strong", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }, children)));
};
//# sourceMappingURL=Title.js.map